export enum SbpMethod {
  LETTER = 'LETTER',
  BALANCE = 'BALANCE',
  CARD = 'CARD',
}
